/** Lao display for KPI target_unit values */

export function labelKpiTargetUnit(unit: string | null): string {
  if (!unit) return "";
  switch (unit) {
    case "percent":
      return "%";
    case "count":
      return "ຄັ້ງ";
    case "score":
      return "ຄະແນນ";
    case "currency":
      return "ກີບ";
    case "none":
      return "";
    default:
      return unit;
  }
}
